module.exports = __webpack_public_path__ + "img/hteam.b18029fc.jpeg";